// extracted by mini-css-extract-plugin
export default {"stepperCover":"styles_stepperCover__7FmkY","mainContainer":"styles_mainContainer__4C3wJ","btnContainer":"styles_btnContainer__ZCOZt"};